import { defineComponent } from "vue";
const _sfc_main = defineComponent({
  name: "SaveAnnotation"
});
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
};
const _hoisted_2 = /* @__PURE__ */ _createElementVNode("path", {
  "fill-rule": "evenodd",
  d: "M18 15.75H20.25C21.0784 15.75 21.75 15.0784 21.75 14.25V3.75C21.75 2.92157 21.0784 2.25 20.25 2.25H5.25C4.42157 2.25 3.75 2.92157 3.75 3.75V6H5.25V3.75H20.25V14.25H18V15.75ZM13.56 8.0625L16.17 11.325C16.3833 11.5909 16.4997 11.9216 16.5 12.2625V21C16.5 21.8284 15.8284 22.5 15 22.5H3C2.17157 22.5 1.5 21.8284 1.5 21V9C1.5 8.17157 2.17157 7.5 3 7.5H12.39C12.8451 7.50028 13.2755 7.70721 13.56 8.0625ZM18.75 5.25H14.25V6.75H18.75V5.25ZM18.75 8.25H15.75V9.75H18.75V8.25ZM11.25 9H6.75V11.25H11.25V9ZM11.25 21H6.75V16.5H11.25V21ZM12.75 16.5V21H15V12.2625L12.75 9.45V11.25C12.75 12.0784 12.0784 12.75 11.25 12.75H6.75C5.92157 12.75 5.25 12.0784 5.25 11.25V9H3V21H5.25V16.5C5.25 15.6716 5.92157 15 6.75 15H11.25C12.0784 15 12.75 15.6716 12.75 16.5Z",
  "clip-rule": "evenodd"
}, null, -1);
const _hoisted_3 = [
  _hoisted_2
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3);
}
import _export_sfc from "/plugin-vue/export-helper";
export default /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render], ["__file", "/Users/yimingtian/projects/ym/yimian-ui/packages/icons/src/SaveAnnotation.vue"]]);
